<template>
  <div
    class="card-main"
    @click="onClick"
    @mouseover="focusOn"
    @mouseleave="focusOut"
  >
    <div class="inner">
      <img class="card-img" src="@/assets/button-plus-80.png" />
      <div class="card-text">더보기</div>
    </div>
    <div class="focus-ring" v-show="isfocusOn && mouseActivated"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActiveVue: true,
      isfocusOn: false,
    };
  },
  props: ["cardData", "isFocusedLine"],

  computed: {
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
  },

  methods: {
    onClick() {
      if (this.isfocusOn) {
        this.clickCard();
      }
    },
    clickCard() {
      this.$router.push({
        name: "program-detail",
        params: {
          title: this.cardData.name,
          programId: this.cardData.programId,
          t: new Date().getTime(),
        },
      });
      this.focusOut();
    },
    focusOn() {
      if (this.isFocusedLine) {
        this.isfocusOn = true;
      }
    },
    focusOut() {
      this.isfocusOn = false;
    },
  },
};
</script>

<style scoped>
.card-main {
  position: relative;
  display: inline-block;
  margin-right: 20px;
  width: 366px;
  height: 308px;
  /* height: 410px; */
  z-index: 2;
}

.focus-ring {
  position: absolute;
  left: -5px;
  top: -4px;
  width: 366px;
  height: 308px;
  border: solid 4px #eeeeee;
  z-index: 5;
}
.inner {
  width: 366px;
  height: 308px;
  text-align: center;
  background-color: #1e1e1e;
}
.card-img {
  top: 86px;
  width: 80px;
  height: 80px;
}
.card-text {
  margin-top: 110px;
  font-size: 24px;
  text-align: center;
  color: #ededed;
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .card-main {
    position: relative;
    display: inline-block;
    margin-right: 20px;
    width: 244px;
    height: 227px;
    /* height: 410px; */
    z-index: 2;
  }

  .focus-ring {
    position: absolute;
    left: -5px;
    top: -4px;
    width: 250px;
    height: 233px;
    border: solid 3px #eeeeee;
    z-index: 5;
  }
  .inner {
    width: 244px;
    height: 227px;
    text-align: center;
    background-color: #1e1e1e;
    position: relative;
  }
  .card-img {
    top: 56px;
    width: 64px;
    height: 64px;
  }
  .card-text {
    position: absolute;
    bottom: 57px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 22px;
    text-align: center;
    color: #ededed;
  }
}
</style>